<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row p-0 mt-5">
    <div class="row pr-0">
        <div class="col-md-10 col-10">
            <h2 class="titleppal">Matriz de acceso</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="col-2 cerrarafil text-right">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
        <div [formGroup]="form" fxFlex="auto" fxLayout="row" class="row pr-0 filtrosTable align-items-center" autocomplete="off">

        </div>
    </div>
    <div class="row pl-0 pr-3" style="padding-left: 25px;">

        <div class="mat-elevation-z8 p-0" *ngIf="!this.mostrarCargando">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                    <!-- columnas -->
                    <ng-container [matColumnDef]="item.id" *ngFor="let item of this.columnasEncabezadoSinAcciones">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{item.descripcion}}</th>
                        <td mat-cell *matCellDef="let row">
                            <div *ngIf="item.id === '0-rol-lectura'">
                                {{row[item.id]}}
                            </div>
                            <div *ngIf="item.id === '0-rol-escritura'">

                            </div>
                            <div *ngIf="item.id !== '0-rol-lectura' && item.id !== '0-rol-escritura'">
                                <mat-checkbox [(ngModel)]="row[item.id]" [disabled]="!row.editando">
                                </mat-checkbox>
                            </div>
                        </td>
                    </ng-container>
                    <!-- acciones Column -->
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                        <td mat-cell *matCellDef="let row">
                            <a type="button" class="icnTable" (click)="Editar(row)" *ngIf="!row.editando && !this.editandoRegistro">
                                <mat-icon>edit</mat-icon>
                            </a>
                            <a type="button" class="icnTable" (click)="Guardar(row)" *ngIf="row.editando">
                                <mat-icon>save</mat-icon>
                            </a>
                            <a type="button" class="icnTable" (click)="CancelarEditar(row)" *ngIf="row.editando">
                                <mat-icon>close</mat-icon>
                            </a>
                        </td>
                    </ng-container>

                    <!-- encabezados agrupados -->
                    <ng-container [matColumnDef]="item" *ngFor="let item of columnasEncabezadoAgrupado">
                        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'" [attr.colspan]="2">
                            {{item}}
                        </th>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnasEncabezadoAgrupado"></tr>
                    <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="col-md-12 col-lg-12 col-12" style="text-align: right;">
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>
</div>